import wrapWithProvider from './wrap-with-provider';

export const wrapPageElement = wrapWithProvider;
